import moment from 'moment-timezone'
import {API_TOW, API_HTML} from "@/config"
import {putDownload} from '@/api/diario';

export function mesesName(mes, all = false) {
    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    if (all) {
        return meses
    }
    return meses[mes];
}

export function dataExtenso(_data) {
    const dias = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-Feira', 'Sexta-feira', 'Sábado', 'Domingo'];
    const data = moment(_data).add(3, 'h');
    return `${dias[data.weekday()]}, ${data.date()} de ${mesesName(data.month())} de ${data.year()}`.toUpperCase();
}

export function nomeArquivoDiario(diario) {
    const date = moment(String(diario.dia_data_publicacao)).add(3, 'h');
    return `DIÁRIO OFICIAL Nº ${diario.dia_numero}, ${dataExtenso(date.format('YYYY-MM-DD'))}.pdf`;
}

export function dowloadDiario(diario, tipo = 'PDF') {
    putDownload(diario).then();
    if (tipo === 'ONLINE') {
        window.open(`${API_TOW}visualizar/${diario.dia_codigo}?q=${Math.ceil(Math.random() * 1000000)}`, "_blank");
    }
    if (tipo === 'PDF') {
        window.open(`${API_TOW}dowload_diario/${diario.dia_codigo}?q=${Math.ceil(Math.random() * 1000000)}`, "_blank");
    }
    if (tipo === 'ZIP') {
        window.open(`${API_TOW}publicacoes_zip/${diario.dia_codigo}?q=${Math.ceil(Math.random() * 1000000)}`, "_blank");
    }
    if (tipo === 'HTML') {
        window.open(`${API_HTML}${diario.dia_codigo}.html?q=${Math.ceil(Math.random() * 1000000)}`, "_blank");
    }
}
